import React, { FC, ReactElement } from 'react'
import styles from './WalletCollectionRow.module.css'
import { Inscription } from '@/utils/types/inscription'
import { WalletTabs } from '../'
import WalletItems from '../wallet-items'
import CollectionStat from '@/components/collection-stat'
import CollectionSatoshiStat from '@/components/collection-satoshi-stat'
import classNames from 'classnames'
import Link from '@/components/link'
import CollectionIcon from '@/components/collection-icon'
import { Collection } from '@/utils/types/collections'

interface WalletCollection {
	name: string
	slug: string
	icon_inscription_id: string
	icon: string
	floor_price: number
	inscriptions: Inscription[]
}

const WalletCollectionRow: FC<{
	isLoading: boolean
	selectedTab: WalletTabs
	columns: any
	collection: WalletCollection
	mutate: () => void
	onSelectBulk?: (id: string) => void
}> = (props): ReactElement => {
	const {
		isLoading,
		columns: _columns,
		collection,
		mutate,
		selectedTab
	} = props
	let inscriptions = collection?.inscriptions
	const collectionSatoshis = collection?.floor_price * collection?.inscriptions?.length

	return (
		<div className={styles.root}>
			{collection?.name && (
				<div className={styles.header}>
					<Link href={`/collection/${collection?.slug}`}>
						<div className={styles.nameContainer}>
							<CollectionIcon
								className={styles.icon}
								imageClassName={styles.icon}
								// @ts-ignore
								collection={collection as Collection}
							/>
							<p className={classNames('text-lg', 'semibold')}>{collection?.name}</p>
						</div>
					</Link>
					<div className={styles.stats}>
						<CollectionStat
							className={styles.stat}
							title="ITEMS"
							value={collection?.inscriptions?.length}
							variant="small"
						/>
						<CollectionSatoshiStat
							className={styles.stat}
							title="FLOOR"
							satoshis={collection?.floor_price}
							variant="small"
						/>
						{selectedTab !== 'Listed' && (
							<CollectionSatoshiStat
								className={styles.stat}
								title="TOTAL"
								satoshis={collectionSatoshis}
								variant="small"
							/>
						)}
					</div>
				</div>
			)}
			<WalletItems
				isLoading={isLoading}
				selectedTab={selectedTab}
				columns={[]}
				filter="collections"
				inscriptions={inscriptions}
				mutate={mutate}
			/>
		</div>
	)
}

export default WalletCollectionRow
